import { Helmet } from "react-helmet";

// SEO Meta Tags Component
export const SEOHead = () => (
  <Helmet>
    {/* Character Set & Viewport */}
    <meta charSet="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    {/* Primary Meta Tags */}
    <title>MH Strategy Tracker 2.0</title>
    <meta
      name="description"
      content="A unified platform to monitor progress, track proposals, manage workflows, and measure real-world impact. Track 300+ active projects across 15+ countries impacting 1,394,269+ lives."
    />
    <meta
      name="keywords"
      content="muslim hands, mh strategy tracker, muslim hands strategy tracker ,project management, impact tracking, NGO, Muslim Hands, humanitarian, development, CRM, proposal management, grievance management, results framework"
    />
    {/* Open Graph Meta Tags */}
    <meta
      property="og:title"
      content="MH Strategy Tracker 2.0 - Muslim Hands"
    />
    <meta
      property="og:description"
      content="Manage Projects, Track Impact - A unified platform for monitoring progress and measuring real-world impact"
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://strategytracker.net/" />
    <meta property="og:image" content="src/assets/MH_logo.png" />
    <meta property="og:site_name" content="Muslim Hands Strategy Tracker" />

    {/* Twitter Meta Tags */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="MH Strategy Tracker 2.0" />
    <meta
      name="twitter:description"
      content="Manage Projects, Track Impact - All in one place"
    />
    <meta name="twitter:image" content="src/assets/MH_logo.png" />
    {/* Additional Important Meta Tags */}
    <meta name="author" content="Muslim Hands" />
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href="https://strategytracker.net/" />
    {/* Favicon */}
    <link rel="icon" href="/public/logo.png" />
    <link rel="apple-touch-icon" sizes="180x180" href="/public/logo.png" />
    {/* Theme Color */}
    <meta name="theme-color" content="#ffffff" />

    {/* Structured Data for SEO */}
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Muslim Hands Strategy Tracker",
        alternateName: "MH Strategy Tracker 2.0",
        url: "https://strategytracker.net/",
        logo: "src/assets/MH_logo.png",
        description:
          "A unified platform to monitor progress, track proposals, manage workflows, and measure real-world impact across 15+ countries",
        foundingDate: "2022",
        address: {
          "@type": "PostalAddress",
          streetAddress: "148 Gregory Boulevard",
          addressLocality: "Nottingham",
          addressCountry: "UK",
        },
        // contactPoint: {
        //   "@type": "ContactPoint",
        //   email: "info@muslimhands.org",
        //   contactType: "customer service",
        // },
        sameAs: [
          "https://www.facebook.com/MuslimHands/",
          "https://x.com/muslimhandsuk",
          "https://www.instagram.com/muslimhandsuk",
          "https://www.linkedin.com/company/muslimhands/",
        ],
        areaServed: "Worldwide",
        knowsAbout: [
          "Humanitarian Response",
          "Development Programs",
          "Project Management",
          "Impact Measurement",
        ],
      })}
    </script>
  </Helmet>
);
